import { resolveOriginDestinationStops } from '@/map/operational/shipment-list-map-layers';
import type { V2ShipmentDetail } from '@gpx-spa/queries/src/getAccountShipmentV2';

export type ShipmentEndpointDirection = 'from' | 'to';

const PLACEHOLDER = '-';

function stopDisplayName(stop: { name?: string | null } | null | undefined): string {
  const name = stop?.name?.trim();
  return name ? name : PLACEHOLDER;
}

/** Origin (from) or destination (to) label from V2 shipment `stops`. */
export function shipmentEndpointDisplayName(
  shipment: V2ShipmentDetail | null | undefined,
  direction: ShipmentEndpointDirection,
): string {
  if (!shipment?.stops?.length) {
    return PLACEHOLDER;
  }

  const { origin, destination } = resolveOriginDestinationStops(shipment.stops);
  const stop = direction === 'from' ? origin : destination;
  if (!stop) {
    return PLACEHOLDER;
  }

  return stopDisplayName(stop);
}
